import React from 'react';
import { Box, Typography } from '@mui/material';
import CartoonButton from '../../CartoonButton.component';
import { SubmittedBadge, labelStyle } from './ClosestNumber.game';
import { MinigameStateSnapshot } from '../../../shared/events';

interface Props {
  minigame: MinigameStateSnapshot;
  submitted: boolean;
  onSubmit: (answer: string) => void;
}

const PickASide: React.FC<Props> = ({ minigame, submitted, onSubmit }) => {
  const [optA, optB] = minigame.options ?? ['A', 'B'];

  if (submitted) return <SubmittedBadge />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: '100%', maxWidth: 400 }}>
      <Typography sx={{ ...labelStyle, fontSize: '1.1rem' }}>{minigame.question ?? 'Pick a side'}</Typography>
      <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem' }}>
        The minority wins!
      </Typography>
      <Box sx={{ display: 'flex', gap: 3, width: '100%' }}>
        <CartoonButton
          variant="contained"
          onClick={() => onSubmit(optA)}
          fullWidth
          sx={{ background: '#3f51b5', height: 80, fontSize: '1.5rem', boxShadow: '0 6px 0 rgba(0,0,0,0.4)' }}
        >
          {optA}
        </CartoonButton>
        <CartoonButton
          variant="contained"
          onClick={() => onSubmit(optB)}
          fullWidth
          sx={{ background: '#e91e63', height: 80, fontSize: '1.5rem', boxShadow: '0 6px 0 rgba(0,0,0,0.4)' }}
        >
          {optB}
        </CartoonButton>
      </Box>
    </Box>
  );
};

export default PickASide;
